const userRole = {
  version: '1.0',
  type: 'enum',
  UserRole: {
    values: [
      'admin',
      'lead designer',
      'designer',
      'smm',
      'client',
    ]
  }
};

export default userRole;
